import script from "./Management.vue?vue&type=script&setup=true&lang=js"
export * from "./Management.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__